module.exports = __webpack_public_path__ + "img/MAGAZINE & VACUUM LOADER(Combination).886a95ae.jpg";